import {createUseStyles} from 'react-jss';
import Typography from '../../style-helper/Typography';

export default createUseStyles({
  importTaxHelpContent: {
    padding: '2em',
    fontSize: props => ((props.isUsingArtemisStyles && props.theme.typography?.[Typography.small]?.largeDevice)
      ? props.theme.typography[Typography.small].largeDevice.fontSize
      : 14),
  },
  
  sectionHeader: {
    fontSize: props => ((props.isUsingArtemisStyles && props.theme.typography?.[Typography.body]?.largeDevice)
      ? props.theme.typography[Typography.body].largeDevice.fontSize
      : 16),
  },
});
